import React, { useContext } from "react";
import { BetslipContext } from "../../data/betslip/BetslipConf";
import { classIf } from "../../data/utils";
import { getLabel } from "../../InitData";

export default function TypeSelector(props) {
    const betslipContext = useContext(BetslipContext) ;
    let betslipData = betslipContext.getBetslipData();
    const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    const current = coupon.selectedContainer;
    const isSinglebets = current === 'singlebets' || (current === 'multibets' && coupon.selections.length === 1 && coupon.selections[0].bets.length === 1);
    const isMultibets =  current === 'multibets' &&  (coupon.selections.length > 1 || coupon.selections[0]?.bets.length > 1);
    const isSystembets = current === 'systembets';

    return (
        <div className="b_4_1">
            <div className={"b_4_1_1" + classIf(isSinglebets || isMultibets, 'active')} onClick={() => betslipContext.changeContainer('multibets')}>
                <div className="b_4_1_1_1">{isSinglebets? getLabel('general.singola') : getLabel('general.multipla')}</div>
            </div>
            <div className={"b_4_1_1" + classIf(isSystembets, 'active')} onClick={() => betslipContext.changeContainer('systembets')}>
                <div className="b_4_1_1_1">{getLabel('general.sistemi')}</div>
            </div>
        </div>
    );
}
